import script from "./FeatureRequestSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./FeatureRequestSidebar.vue?vue&type=script&setup=true&lang=js"

import "./FeatureRequestSidebar.vue?vue&type=style&index=0&id=295068a1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-295068a1"]])

export default __exports__